var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable */
import React, { useState, useEffect, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLoadingRedux } from 'reducers/sharedata/action';
import { setUserMenusRedux, setUserInfoRedux, setApplicationCodesRedux, } from 'reducers/Login/action';
import { setUserMenuLayouts, setSidebarItems } from 'reducers/Layout/action';
import Axios from 'axios';
import { APP_PATH, HOST } from 'config';
import { customlog } from 'component/utility/CustomLog';
import Hidden from '@material-ui/core/Hidden';
import { useSnackbar } from 'notistack';
import twmsToolbarRoutes from 'routes/twmsToolbarRoutes';
import SYS_Routes from 'routes/Project/SYS_Routes';
import INQ_Routes from 'routes/Project/INQ_Routes';
import DOC_Routes from 'routes/Project/DOC_Routes';
import PAY_Routes from 'routes/Project/PAY_Routes';
import REL_Routes from 'routes/Project/REL_Routes';
import TRK_Routes from 'routes/Project/TRK_Routes';
import USR_Routes from 'routes/Project/USR_Routes';
import CNM_Routes from 'routes/Project/CNM_Routes';
import INV_Routes from 'routes/Project/INV_Routes';
import { dAxios } from 'consts';
import ADV_ROUTES from 'routes/Project/ADV_Routes';
import { getUserDataRedux, getUserMenusRedux } from 'reducers/Login/selector';
import { getSidebarOpen } from 'reducers/Layout/selector';
import { getResetKeyRedux } from 'reducers/sharedata/selector';
import TitleandTool from './TitleandTool';
import MenuShow from './MenuShow';
import SidebarList from './SidebarList';
import ORD_ROUTES from 'routes/Project/ORD_Routes';
var TwmsMaterialStyle = require('./TwmsMaterialStyle.module.css');
/*
    Usage: 功能頁的Route設定
*/
var switchRoutesItem = function (props) {
    return props.map(function (prop, idx) {
        return prop.children ? (switchRoutesItem(prop.children)) : (React.createElement(Route, { key: idx, path: APP_PATH + prop.path, component: prop.component }));
    });
};
/*
    Usage: 功能頁的畫面顯示
*/
var switchRoutes = function (userMenu) { return (
// console.log("switchRoutes")
// const accessMenu = SYS_Routes.filter(function f(el) {
//     let ok = false;
//     userMenu.map((prop) => {
//         if (prop.menuUrl === el.path) {
//             ok = true;
//         }
//     })
//     return ok;
// })
React.createElement(React.Fragment, null,
    React.createElement(Suspense, { fallback: React.createElement("div", null, "\u8F09\u5165\u4E2D...") },
        React.createElement(Switch, null,
            switchRoutesItem(twmsToolbarRoutes),
            switchRoutesItem(SYS_Routes),
            switchRoutesItem(USR_Routes),
            switchRoutesItem(INQ_Routes),
            switchRoutesItem(DOC_Routes),
            switchRoutesItem(PAY_Routes),
            switchRoutesItem(INV_Routes),
            switchRoutesItem(REL_Routes),
            switchRoutesItem(TRK_Routes),
            switchRoutesItem(CNM_Routes),
            switchRoutesItem(ADV_ROUTES),
            switchRoutesItem(ORD_ROUTES))))); };
var TwmsMaterial = function (props) {
    var userId = useSelector(getUserDataRedux).userId;
    var userMenu = useSelector(getUserMenusRedux);
    var sidebarOpen = useSelector(getSidebarOpen);
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var dispatch = useDispatch();
    var _a = useState('calc(100vh - 114px)'), height = _a[0], setHeight = _a[1];
    var _b = useState('calc(100vh - 40px)'), mobileHeight = _b[0], setMobileHeight = _b[1];
    var _c = useState('0'), width = _c[0], setWidth = _c[1];
    var _d = useState(false), pwNeedChange = _d[0], setPwNeedChange = _d[1];
    var _e = useState(-1), daysBeforeInterval = _e[0], setDaysBeforeInterval = _e[1];
    var _f = useState(''), errorReason = _f[0], setErrorReason = _f[1];
    var _g = useState(''), errorHappen = _g[0], setErrorHappen = _g[1];
    // 非使用可以使用的 taskId 轉回 homepage
    useEffect(function () {
        if (userMenu.length > 0) {
            var pathArray = props.history.location.pathname.split('/');
            var ezwayIdx = pathArray.findIndex(function (obj) { return obj === APP_PATH.substring(1); });
            if (pathArray.length > ezwayIdx + 2) {
                var codeId_1 = pathArray[ezwayIdx + 2];
                if (codeId_1 && userMenu.findIndex(function (obj) { return obj.taskId === codeId_1; }) < 0) {
                    props.history.push(APP_PATH + "/homepage");
                }
            }
        }
    }, [userMenu]);
    useEffect(function () {
        customlog('twmsMaterial DidMount');
        if (window.sessionStorage.jwt) {
            setAxios();
            initParams();
            setWidth('calc(100% - 200px)');
            if (props.history.location.pathname === APP_PATH) {
                props.history.push(APP_PATH + "/homepage");
            }
            if (errorReason !== '') {
                props.history.push(errorReason);
                setErrorReason('');
                setErrorHappen(errorReason);
            }
        }
        else {
            setErrorReason('/error500');
        }
    }, []);
    var initParams = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUserInfo()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getUserMenu()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getUserInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setLoadingRedux(1));
                    return [4 /*yield*/, dAxios('POST', HOST + "v3/user/userdtl", { userId: userId, lang: 'TW' }, enqueueSnackbar)];
                case 1:
                    response = _a.sent();
                    dispatch(setLoadingRedux(-1));
                    if (!response || response.data.status !== 'Y') {
                        setErrorReason('/error500');
                        return [2 /*return*/];
                    }
                    dispatch(setUserInfoRedux(response.data.data || []));
                    return [2 /*return*/];
            }
        });
    }); };
    var setAxios = function () {
        Axios.defaults.headers.Authorization = window.sessionStorage.jwt;
        // Axios.defaults.headers.Authorization = this.props.jwtData;
        // Axios.defaults.headers.loginUserId = this.props.userId;
        Axios.defaults.timeout = 30000;
        // 回應錯誤跳轉錯誤頁
        Axios.interceptors.response.use(function (response) { return response; }, function (error) {
            if (error.code === 'ECONNABORTED') {
                var msg = "request timeout: " + error.config.url;
                enqueueSnackbar(msg, { variant: 'warning' });
                return Promise.resolve();
            }
            console.log(error);
            if (error.response) {
                if (error.response.status === 403) {
                    setErrorReason('/error500');
                }
                else if (error.response.status === 500) {
                    setErrorReason('/error500');
                }
                else if (error.response.status === 401 &&
                    error.response.data.status === 'O') {
                    // 不直接回登入頁 在 goAxios 裡 catch 更新 token 更重發 axios
                }
                else {
                    setErrorReason('/error500');
                }
            }
            return Promise.reject(error);
        });
    };
    useEffect(function () {
        if (errorReason !== '') {
            props.history.push(errorReason);
        }
    }, [errorReason]);
    /** 建立使用者可操作的menu data */
    var getUserMenu = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, userMenuData, applicationCodeList, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setLoadingRedux(1));
                    return [4 /*yield*/, dAxios('get', HOST + "v1/user/user-menu", { userId: userId, lang: 'TW' }, enqueueSnackbar, { timeout: 25000 })];
                case 1:
                    response = _a.sent();
                    dispatch(setLoadingRedux(-1));
                    if (!response || response.data.status !== 'Y') {
                        setErrorReason('/error500');
                        return [2 /*return*/];
                    }
                    userMenuData = response.data.data.sub || [];
                    applicationCodeList = response.data.data.main || [];
                    dispatch(setUserMenusRedux(userMenuData));
                    dispatch(setApplicationCodesRedux(applicationCodeList));
                    data = [];
                    applicationCodeList.map(function (prop) {
                        var children = userMenuData.filter(function (el) { return el.parentId === prop.menuId; });
                        if (children.length !== 0) {
                            var o = {};
                            o.codeId = prop.taskId;
                            o.menuId = prop.menuId;
                            o.taskName = prop.taskName;
                            o.children = children;
                            o.children.map(function (pro) {
                                var child = userMenuData.filter(function (ele) { return ele.parentId === pro.menuId; });
                                if (child.length !== 0) {
                                    pro.children = child;
                                }
                                return pro;
                            });
                            data.push(o);
                        }
                    });
                    dispatch(setSidebarItems(data[0].children));
                    dispatch(setUserMenuLayouts(data));
                    return [2 /*return*/];
            }
        });
    }); };
    // 隨Sidebarlist的開啟狀態調整功能畫面的寬度
    useEffect(function () {
        setWidth(sidebarOpen ? 'calc(100% - 200px)' : '100%');
    }, [sidebarOpen]);
    var resetKey = useSelector(getResetKeyRedux);
    return (React.createElement("div", { key: resetKey }, errorHappen === '' ? (React.createElement("div", null,
        React.createElement(TitleandTool, { pwNeedChange: pwNeedChange, daysBeforeInterval: daysBeforeInterval }),
        React.createElement(MenuShow, { urlPath: props.history.location.pathname }),
        React.createElement(SidebarList
        // handleItemClick={this.handleItemClick}
        // breadCrumbApplicationCode={breadCrumbApplicationCode}
        // breadCrumbTaskId={breadCrumbTaskId}
        , { 
            // handleItemClick={this.handleItemClick}
            // breadCrumbApplicationCode={breadCrumbApplicationCode}
            // breadCrumbTaskId={breadCrumbTaskId}
            urlPath: props.history.location.pathname }),
        React.createElement(Hidden, { smDown: true },
            React.createElement("div", { id: "functionContent", className: TwmsMaterialStyle.rightContent, style: { width: width, height: height } },
                React.createElement("div", { className: TwmsMaterialStyle.rightContentDisplay }, switchRoutes(userMenu)))),
        React.createElement(Hidden, { mdUp: true },
            React.createElement("div", { id: "functionContent", className: TwmsMaterialStyle.rightContentMobile, style: { height: mobileHeight } },
                React.createElement("div", { className: TwmsMaterialStyle.rightContentDisplay }, switchRoutes(userMenu)))))) : (React.createElement("div", null, switchRoutes(userMenu)))));
};
export default TwmsMaterial;
